import axios from "axios";
import { User } from "./auth";

export type TParamsUser = {
  page: number;
  limit: number;
  search?: string;
  total?: number;
  sortBy?: string;
  order?: string;
};

export type TDataFetchUser = {
  users: User[];
  total: number;
  page: number;
  limit: number;
};

export const getListUSers = (
  params?: TParamsUser
): Promise<{ data: TDataFetchUser }> => {
  return axios.get("/users", { params });
};

export const editUser = (id: number, body: User) => {
  return axios.put(`/users/${id}`, body);
};

export const deleteUser = (id: number) => {
  return axios.delete(`/users/${id}`);
};

export const createUser = (body: User) => {
  return axios.post("/users", body);
};
